import { useTranslation } from "react-i18next";
import { KeywordFeedbackCategory } from "reedy-data/api";
import { Text } from "components/text";
import {
  CATEGORIES,
  CATEGORY_TESTID,
  getCategoryLabel,
  getCategoryTooltip,
} from "./KeywordFeedbackPopover.labels";
import { KeywordFeedbackPill } from "./KeywordFeedbackPill";

interface KeywordFeedbackCategoryPickerProps {
  hoveredCategory: KeywordFeedbackCategory | null;
  onHover: (category: KeywordFeedbackCategory | null) => void;
  onSelect: (category: KeywordFeedbackCategory) => void;
}

export const KeywordFeedbackCategoryPicker = ({
  hoveredCategory,
  onHover,
  onSelect,
}: KeywordFeedbackCategoryPickerProps) => {
  const { t } = useTranslation(["components"]);

  return (
    <div className="px-4 py-3 flex flex-col gap-2">
      <div className="flex flex-wrap gap-1.5">
        {CATEGORIES.map((category) => (
          <KeywordFeedbackPill
            key={category}
            onClick={() => onSelect(category)}
            onMouseEnter={() => onHover(category)}
            onMouseLeave={() => onHover(null)}
            data-testid={`feedback-category-${CATEGORY_TESTID[category]}`}
          >
            {getCategoryLabel(t, category)}
          </KeywordFeedbackPill>
        ))}
      </div>
      <Text variant="caption">
        {hoveredCategory
          ? getCategoryTooltip(t, hoveredCategory)
          : t("components:keywordsTab.keywordFeedbackPopover.hoverHint")}
      </Text>
    </div>
  );
};
